export default class LimitIncreaseConfig {

    static MIN_ADDRESS_DOCUMENTS = 0;
    static MAX_ADDRESS_DOCUMENTS = 9;
    static MIN_INCOME_DOCUMENTS = 1;
    static MAX_INCOME_DOCUMENTS = 9;
}